import { createAsyncThunk } from "@reduxjs/toolkit";

import { guess as guessLocation } from "../../../api/location";
import { ILocationGuessResponse } from "../../../models/location";
import { updateDetectedLocation } from "../../common/reducers";

/**
 * Load the user's detected location.
 *
 * This thunk attempts to automatically detect the user's location using IP geolocation
 * or other browser APIs. The detected location is stored in the common slice state
 * and used for shipping calculations and regional content.
 *
 * @returns {Promise<ILocationGuessResponse | null>} Promise resolving to the detected location or null
 *
 * @example
 * // Load location when configurator initializes
 * dispatch(loadLocation());
 *
 * @sideEffects
 * - Updates `common.detectedLocation` with the guessed location
 */
export const loadLocation = createAsyncThunk(
    "configurator/loadLocation",
    async (_, { dispatch }): Promise<ILocationGuessResponse | null> => {
        const location = await guessLocation();
        if (location) {
            dispatch(updateDetectedLocation(location));
        }
        return location;
    },
);
